import { render, staticRenderFns } from "./CustomerSendForm.vue?vue&type=template&id=0af12b56&"
import script from "./CustomerSendForm.vue?vue&type=script&lang=js&"
export * from "./CustomerSendForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSendForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports